const landingPages = {
  git_basic: {
    username: "subrataindia",
    repo: "tutorials",
    branch: "main",
    file: "git-github/intro.md",
  },
};

export default landingPages;
